import { ClientOnly } from "@tanstack/react-router";
import { useLocale } from "@/i18n/locale-context";
import { LOCALES, LOCALE_LABELS, type Locale } from "@/i18n/types";

function Switcher() {
  const { locale, setLocale, t } = useLocale();
  return (
    <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <span className="sr-only">{t("lang.label")}</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
        className="bg-transparent border border-foreground/15 rounded-full px-2 py-1 text-xs font-medium focus:outline-none focus:border-accent cursor-pointer"
        aria-label={t("lang.label")}
      >
        {LOCALES.map((l) => (
          <option key={l} value={l}>
            {LOCALE_LABELS[l]}
          </option>
        ))}
      </select>
    </label>
  );
}

export function LanguageSwitcher() {
  return (
    <ClientOnly fallback={<div className="h-7 w-20" aria-hidden />}>
      <Switcher />
    </ClientOnly>
  );
}
